import UIService from '@/services/core/ui';

export default {
  install(Vue, { store } = {}) {
    if (!store) {
      console.error('[ui plugin] Vuex store is required');
      return;
    }

    const uiService = new UIService(store);
    Vue.prototype.$uiService = uiService;
  },
};
